import React, { useState } from "react";
import AppBar from "../../components/AppBar";
import Stepper from "../../components/Steppers";
import {
    Grid,
    Box,
    Button,
    CircularProgress,
    Container,
    useMediaQuery,
} from "@material-ui/core";
import { useTheme } from "@material-ui/styles";

//import { unstable_useMediaQuery as useMediaQuery } from '@material-ui/core/useMediaQuery';

import FormPesquisaCreditoPart1 from "../../components/FormPesquisaCredito/FormPesquisaCreditoPart1";
import FormPesquisaCreditoPart2 from "../../components/FormPesquisaCredito/FormPesquisaCreditoPart2";

import useStyles from "./style";
import {toast} from "react-toastify";
import {validCNPJ} from "../../utils/cnpjUtils";
import {validCPF} from "../../utils/cpfUtils";
import {formatBrazilianCurrency} from "../../utils/currencyUtils";

const avisoCampoObrigatorio = (campo) => {
    toast.error(
        `O campo ${campo} é obrigatório!`,
        {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined
        }
    )
}

const avisoCampoInvalido = (campo) => {
    toast.error(
        `O número do documento no campo ${campo.toUpperCase()} está inválido!`,
        {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined
        }
    )
}

const PesquisaCredito = (props) => {
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.up("md"));
    const [document, setDocument] = useState("all");
    const [relatorios, setRelatorios] = useState("");
    const classes = useStyles();

    const handleDocument = (e) => {
        setDocument(e.target.value);
    };

    const handleRelatorios = (e) => {
        setRelatorios(e.target.value);
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        let parametros_portal = null;
        let formIsValid = true;
        const documentType = props.modelos.find((e) => e.id == relatorios).tipo_documento;

        props.modelos.map((e) => {
            if (
                e.id == relatorios &&
                e.parametros_portal &&
                e.parametros_portal.fields
            ) {
                e.parametros_portal.fields.map((e) => {
                    let currentValue = event.target.elements[e.name].value
                    if (e.type == "currency"){
                        currentValue = formatBrazilianCurrency(currentValue)
                    }
                    parametros_portal = {
                        ...parametros_portal,
                        ...{ [e.name]: currentValue },
                    };
                });
            }
        });
        const documento = event.target.elements["documento"].value.replace(
            /[^\d]/g,
            ""
        );
        if (documentType == "cnpj" && !validCNPJ(documento)){
            avisoCampoInvalido(documentType);
            formIsValid = false;
        }
        else if (documentType == "cpf" && !validCPF(documento)){
            avisoCampoInvalido(documentType);
            formIsValid = false;
        }

        const data = {
            id_modelo: relatorios,
            documento,
            parametros_portal,
            parametros_extra: {},
        };

        props.modelos.forEach((e) => {
            if (
                e.id == relatorios &&
                e.parametros_portal &&
                e.parametros_portal.fields
            ) {
                e.parametros_portal.fields.forEach((e) => {
                    if (event.target.elements[e.name]) {
                        if (e.required && (event.target.elements[e.name].value == null || event.target.elements[e.name].value == "")) {
                            avisoCampoObrigatorio(e.label);
                            formIsValid = false;
                        }
                    }
                });
            }
        });
        if (formIsValid === true){
            props.submitRelatorio(data);
            event.target.elements["documento"].value = "";
            props.modelos.forEach((e) => {
                if (
                    e.id == relatorios &&
                    e.parametros_portal &&
                    e.parametros_portal.fields
                ) {
                    e.parametros_portal.fields.forEach((e) => {
                        if (event.target.elements[e.name]) {
                            event.target.elements[e.name].value = null;
                        }
                    });
                }
            });
            setRelatorios("");
        }
    };

    return (
        <div>
            <AppBar fecharModal={props.fecharModal} />
            <div className={classes.scrollContainer}>
                <Grid className={`${classes.root} ${classes.scroll}`}>
                    <Container>
                        <Box component={"div"} my={8}>
                            <Grid
                                container
                                item
                                justifyContent={
                                    !matches ? "center" : "flex-start"
                                }
                                alignItems="center"
                                md={7}
                                xs={12}
                            >
                                <Stepper relatorios={relatorios} />
                            </Grid>
                        </Box>

                        <form onSubmit={handleSubmit}>
                            <Grid
                                container
                                direction="row"
                                justifyContent={!matches ? "center" : "center"}
                            >
                                <Grid item md={6} sm={7} xs={11}>
                                    <FormPesquisaCreditoPart1
                                        modelos={props.modelos}
                                        mediaquery={matches}
                                        document={document}
                                        relatorios={relatorios}
                                        handleRelatorios={handleRelatorios}
                                        handleDocument={handleDocument}
                                    />
                                </Grid>
                                <Grid item md={6} sm={7} xs={11}>
                                    <FormPesquisaCreditoPart2
                                        document={document}
                                        mediaquery={matches}
                                        relatorios={relatorios}
                                        modelos={props.modelos}
                                    />
                                </Grid>
                            </Grid>
                            <Grid
                                container
                                direction="row"
                                justifyContent={
                                    !matches ? "center" : "flex-end"
                                }
                                alignItems="center"
                            >
                                <Grid
                                    item
                                    md={5}
                                    sm={7}
                                    xs={11}
                                    style={{ paddingBottom: "1.5rem" }}
                                >
                                    {!props.loading ? (
                                        <Button
                                            type="submit"
                                            variant="contained"
                                            color="primary"
                                            style={
                                                !matches
                                                    ? {
                                                          width: "100%",
                                                          marginBottom: "4rem",
                                                          marginTop: "2rem",
                                                      }
                                                    : {
                                                          float: "left",
                                                          marginLeft: "17rem",
                                                      }
                                            }
                                        >
                                            Consultar
                                        </Button>
                                    ) : (
                                        <Button
                                            color="primary"
                                            variant="contained"
                                            style={
                                                !matches
                                                    ? {
                                                          width: "100%",
                                                          marginBottom: "4rem",
                                                          marginTop: "2rem",
                                                      }
                                                    : {
                                                          float: "left",
                                                          marginLeft: "17rem",
                                                      }
                                            }
                                        >
                                            <CircularProgress
                                                style={{ width: "40px" }}
                                                disableShrink
                                            />
                                        </Button>
                                    )}
                                </Grid>
                            </Grid>
                        </form>
                    </Container>
                </Grid>
            </div>
        </div>
    );
};

export default PesquisaCredito;
